module.exports = __webpack_public_path__ + "img/deactivation-success-confettis.8b6e59d0.svg";